import { lazy } from 'react';

export const SyncstripelogPage = lazy(() => import('./page-list'));
